<template>
    <div class="panelWrap">
        <div v-if="showDetailType">
            <DetailInfo />
        </div>
        <div v-else>
            <div class="top">
                <div class="top-left ashComWrap">
                    <HeadTipsBtn v-if="titleLeft?.length" :listData="titleLeft || []" modalName='left'
                        :activeTitle="activeTitle" @change-title="changeTitle" />
                    <el-empty v-else class="empty" :image-size="80" description="暂无数据"></el-empty>
                </div>
                <div v-if="energyType==='cool'" class="top-right ashComWrap">
                    <HeadTipsBtn v-if="titleRight?.length" :listData="titleRight || []" together modalName='right'
                        :activeTitle="activeTitle" @change-title="changeTitle" />
                    <el-empty v-else class="empty" :image-size="80" description="暂无数据"></el-empty>
                </div>
            </div>
            <BottomDefault v-if="bottomType === 'default'" :assetId="assetId" :energyType="energyType"/>
            <BottomDevice v-if="bottomType === 'device'" :assetId="assetId" :deviceTypes="deviceTypes" :energyType="energyType"/>
        </div>
    </div>
</template>
<script>
import HeadTipsBtn from "@/components/HeadTips/HeadTipsBtn";
import TitleTips from '@/components/TitleTips/TitleTips.vue';
import TitleTipsItem from '@/components/TitleTips/TitleTipsItem.vue';
import BottomDevice from "./BottomDevice.vue";
import BottomDefault from "./BottomDefault.vue";
import DetailInfo from "./DetailInfo.vue";
export default {
    components: { HeadTipsBtn, TitleTips, TitleTipsItem, BottomDefault, BottomDevice, DetailInfo },
    name: "Panel",
    props: {
        titleLeft: {
            type: Array,
            default: () => ([])
        },
        titleRight: {
            type: Array,
            default: () => ([])
        },
        showDetailType: {
            type: Boolean,
            default: false,
        },
        assetId: {
            type: String,
            default: null,
        },
        //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
        energyType: {
            type: String,
            default: "cool",
        },
    },
    data() {
        return {
            bottomType: "default",       //"default"为默认界面，"device"为设备界面
            activeTitle: { activeModal: 'left', activeIndex: null },
        }
    },
    computed: {
        deviceTypes: function () {
            const index = this.activeTitle?.activeIndex || 0
            if (this.activeTitle.activeModal === "right") {
                return "主机能效"
            } else {
                return this?.titleLeft?.[index]?.name
            }
        }
    },
    methods: {
        changeTitle(activeObj) {
            const newActive = this._.cloneDeep(activeObj)
            //第二次点中取消选中
            if (newActive.activeIndex === this.activeTitle.activeIndex) {
                this.activeTitle.activeIndex = null
                this.bottomType = "default"
                return false;
            } else if (this.bottomType !== "device") {
                this.bottomType = "device"
            }
            this.activeTitle = newActive
        }
    },
    mounted() {
        console.log("Panel--assetId--", this.assetId);
    },
}
</script>
<style  lang="scss" scoped>
.panelWrap {
    width: 100%;
    height: 100%;

    .top {
        height: 200px;
        @include setFlexBetween;

        &-left {
            flex-grow: 1;

            &-content {
                padding-left: 15px;
            }
        }

        &-right {
            margin-left: 12px;
            width: 371px;
            flex-grow: 0;

            &-content {
                padding-right: 15px;
                @include setFlexBetween;

                &>div {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>